import { render, staticRenderFns } from "./DataTableEditor.vue?vue&type=template&id=6be96972"
import script from "./DataTableEditor.vue?vue&type=script&lang=js"
export * from "./DataTableEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports